<template>
  <div>
    <v-card-text class="overflow-y-auto pa-2" style="
        background-color: #f9f9f9;
        border-radius: 10px;
        overflow-x: hidden;
        max-height: 350px;
      " ref="chatgptMessages">
      <div v-for="(messages, fecha) in groupedMessages" :key="fecha">
        <div v-if="fecha != 'undefined' && fecha == today" style="text-align: center;">
          <v-chip class="ma-2" small style="text-align: center;">
            HOY
          </v-chip>
          <v-divider class="mb-6"></v-divider>
        </div>
        <div v-else-if="fecha != 'undefined'" style="text-align: center;">
          <v-chip class="ma-2" small>
            {{ fecha }}
          </v-chip>
          <v-divider class="mb-6"></v-divider>
        </div>

        <div v-for="msg in messages" :key="msg.id" style="margin-left:10px;">
          <p>
            <v-card color="transparent" class="d-flex justify-end" flat tile
              v-if="msg.file && msg.operator_name == null">
              <a style="text-decoration: none" :href="msg.file" :download="msg.filename" target="_blank">
                <v-sheet color="#d5ecf5" elevation="1" width="100" class="m-10 p-5 preview" rounded style="text-align: center;
                  display: block;
                  margin: 10px 0;
                  position: relative;
                  word-wrap: break-word;">
                  <v-img :src="msg.file" width="100" v-if="msg.type === 'image'"></v-img>

                  <v-icon class="mt-5" size="50" color="#FFDB58"
                    v-if="msg.type && msg.type.match('image.*')">mdi-file-image</v-icon>

                  <v-icon class="mt-5" size="50" color="red"
                    v-if="msg.type && msg.type.match('pdf.*')">mdi-file-pdf-box</v-icon>
                  <v-icon class="mt-5" size="50" color="green"
                    v-if="msg.type && msg.type.match('excel.*')">mdi-file-excel</v-icon>
                  <v-icon class="mt-5" size="50" color="primary"
                    v-if="msg.type && msg.type.match('word.*')">mdi-file-word</v-icon>
                  <v-icon class="mt-5" size="50" color="orange"
                    v-if="msg.type && msg.type.match('presentation.*')">mdi-file-powerpoint</v-icon>
                  <v-icon class="mt-5" size="50" color="purple"
                    v-if="msg.type && msg.type.match('video.*')">mdi-file-video</v-icon>
                  <v-icon class="mt-5" size="50" color="darken" v-if="
                    !msg.type ||
                    (!msg.type.match('pdf.*') &&
                      !msg.type.match('image.*') &&
                      !msg.type.match('excel.*') &&
                      !msg.type.match('word.*') &&
                      !msg.type.match('presentation.*') &&
                      !msg.type.match('video.*'))
                  ">mdi-file</v-icon>
                  <div
                    style="display: flex; flex-direction: column; align-items: center; margin-top: 5px; max-width: 120px;">
                    <p style="margin-top: 5px; overflow: hidden; text-overflow: ellipsis; max-width: 90px;">{{
                      msg.filename }}</p>
                  </div>
                </v-sheet>
              </a>
            </v-card>
          </p>
          <p>
            <v-card color="transparent" class="d-flex justify-end" flat tile>
              <v-card color="#d5ecf5" style="border-radius: 10px 10px 0px; margin-top: 10px;" :elevation="1"
                class="pa-2 mr-1" v-if="msg.user_message && msg.user_message.trim() !== ''" v-html="msg.user_message">
              </v-card>

            </v-card>
            <v-card color="transparent" class="d-flex justify-end mb-6 mr-1" flat tile v-if="
              (msg.user_message || msg.file) && msg.operator_name == null">
              <small class="mt-2" style="font-size: 0.6rem; color: grey">{{ msg.hora }}
              </small>
            </v-card>
          </p>
          <p>
            <v-card color="transparent" class="pa-2 mb-2" flat tile
              v-if="(msg.chatgpt_response || msg.file) && msg.operator_name !== null">
              <a style="text-decoration: none" :href="msg.file" :download="msg.filename" target="_blank"
                v-if="msg.file">
                <v-sheet color="#white" elevation="1" width="100" class="m-10 p-5 preview" rounded style="
                    text-align: center;
                    display: block;
                    margin: 10px 0;
                  ">
                  <v-icon class="mt-5" size="50" color="#FFDB58"
                    v-if="msg.type && msg.type.match('image.*')">mdi-file-image</v-icon>

                  <v-icon class="mt-5" size="50" color="red"
                    v-if="msg.type && msg.type.match('pdf.*')">mdi-file-pdf-box</v-icon>
                  <v-icon class="mt-5" size="50" color="green"
                    v-if="msg.type && msg.type.match('excel.*')">mdi-file-excel</v-icon>
                  <v-icon class="mt-5" size="50" color="primary"
                    v-if="msg.type && msg.type.match('word.*')">mdi-file-word</v-icon>
                  <v-icon class="mt-5" size="50" color="orange"
                    v-if="msg.type && msg.type.match('presentation.*')">mdi-file-powerpoint</v-icon>
                  <v-icon class="mt-5" size="50" color="purple"
                    v-if="msg.type && msg.type.match('video.*')">mdi-file-video</v-icon>
                  <v-icon class="mt-5" size="50" color="darken" v-if="
                    !msg.type ||
                    (!msg.type.match('pdf.*') &&
                      !msg.type.match('image.*') &&
                      !msg.type.match('excel.*') &&
                      !msg.type.match('word.*') &&
                      !msg.type.match('presentation.*') &&
                      !msg.type.match('video.*'))
                  ">mdi-file</v-icon>
                  <div
                    style="display: flex; flex-direction: column; align-items: center; margin-top: 5px; max-width: 120px;">
                    <p style="margin-top: 5px; overflow: hidden; text-overflow: ellipsis; max-width: 90px;">{{
                      msg.filename }}</p>
                  </div>


                </v-sheet>
              </a>
            </v-card>
            <v-row>
              <v-card color="transparent" class="d-flex justify-end mr-4 ml-3" flat tile>
                <v-card color="white" :elevation="1" text-color="#616161" class="pa-2 mb-2"
                  style="border-radius: 10px 10px 10px 0px"
                  v-if="msg.chatgpt_response && msg.chatgpt_response.trim() !== '' && !msg.chatgpt_response.includes('Hola, un gusto. Te saluda')"
                  v-html="msg.chatgpt_response">
                </v-card>
              </v-card>
            </v-row>
            <v-row>
              <v-card color="transparent" class="d-flex justify-end ml-3" style="margin-bottom: 10px;" flat tile
                v-if="((msg.chatgpt_response || msg.file) && msg.operator_name !== null) && !msg.chatgpt_response.includes('Hola, un gusto. Te saluda')">
                <small style="font-size: 0.6rem; margin-bottom:10px; color: grey">
                  {{ msg.hora }}
                </small>
              </v-card>
            </v-row>
          </p>
          <p style="text-align: center">
            <template v-if="msg.system_message">
              <template
                v-if="msg.system_message.includes('El operador ') && msg.system_message.includes(' se ha unido al chat') && !operatorJoined">
                <v-chip class="ma-2" small>
                  {{ msg.system_message }}
                </v-chip>
                <v-card color="transparent" class="mb-6" flat tile>
                  <small class="mt-2" style="font-size: 0.6rem; color: grey">{{ msg.created_at.substr(11, 5) }}
                  </small>
                </v-card>
                <template v-once>
                  <template v-if="operatorJoined = true"></template>
                </template>
              </template>

              <template
                v-else-if="msg.system_message.includes('El operador ') && msg.system_message.includes(' ha abandonado el chat') && operatorJoined">
                <v-chip class="ma-2" small>
                  Conversación finalizada
                </v-chip>
                <v-card color="transparent" class="mb-6" flat tile>
                  <small class="mt-2" style="font-size: 0.6rem; color: grey">{{ msg.created_at.substr(11, 5) }}
                  </small>
                </v-card>
                <template v-once>
                  <template v-if="operatorJoined = false"></template>
                </template>
              </template>
            </template>
          </p>


        </div>
      </div>

      <v-card color="transparent" class="d-flex justify-end" flat tile>
        <v-card color="#d5ecf5" style="border-radius: 10px 10px 0px" :elevation="1" class="pa-2 mr-1"
          v-if="showQuestion">
          {{ messages[messages.length - 1].text }}
        </v-card>
      </v-card>
    </v-card-text>
    <div class="floating-button-container">
      <v-btn v-if="showOperadorButton" @click="solicitarOperador()" class="floating-button-solicitud" outlined>
        <v-icon left>mdi-account</v-icon>
        <span class="body-2">Chatear con un operador</span>
      </v-btn>

      <v-btn v-if="solicitaOperador" class="floating-button-waiting" outlined>
        <v-icon left>mdi-account</v-icon>
        <span class="body-2">conectando con operador...</span>
      </v-btn>

      <!--EN ESPERA DE TERMINAR MODULO DE OPERADOR-
        <v-btn v-if="isWithOperador" class="floating-button-success" outlined>
        <v-icon left>mdi-account</v-icon>
        <span class="body-2" >chateando con un operador</span>
      </v-btn> -->
    </div>
    <v-card-text class="flex-shrink-1" style="position: absolute; bottom: 0;">
      <template>
        <v-text-field v-model="messageForm.content" :label="isSending ? 'Generando respuesta...' : 'Escribe un mensaje'"
          :placeholder="isSending ? 'Generando respuesta...' : ''" type="text" no-details :disabled="isSending" outlined
          prepend-icon="mdi-emoticon" :append-outer-icon="messageForm.content ? 'mdi-send' : 'mdi-attachment'"
          @keyup.enter="sendMessage()" @click:append-outer="
            messageForm.content
              ? sendMessage()
              : attachFile();
          " @click:prepend="showEmojis = !showEmojis" @click="showEmojis = false" @focus="showEmojis = false"
          hide-details clear-icon="mdi-close-circle" clearable />

        <div v-if="showEmojis" style="position: absolute; bottom: 50px; z-index: 1000;">
          <!-- Componente de selección de emojis -->
          <VEmojiPicker class="elevation-1" @select="selectEmoji" emojiSize="25" emojisByRow="9" />
        </div>

      </template>
    </v-card-text>

    <template>
      <v-dialog v-model="isModalVisible" max-width="600">
        <v-card>
          <v-card-title class="text-h5 justify-center" style="color: white; background-color: #007bff;">
            ¿Cómo Fue tu Interacción con {{ this.operadorNombre }}?
            <v-spacer></v-spacer>
            <v-btn icon dark @click="closeModal">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text style="font-size: 1.2em;">
            <p>Por favor, califica tu experiencia:</p>
            <v-rating v-model="rating" length="5" color="yellow darken-3" background-color="grey lighten-1"
              size="48px"></v-rating>
            <v-textarea v-model="opinion" label="Danos tu opinión sobre este Operador" rows="3" outlined
              style="font-size: 1.2em;"></v-textarea>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="justify-center">
            <v-btn color="primary" text @click="submitRating" style="font-size: 1.2em;">
              Enviar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>



      <v-dialog v-model="showImageAttach" max-width="825" scrollable>
        <v-card>
          <v-card-title class="text-h5 justify-center modal-info" style="color: white">
            Adjuntar archivo
            <v-spacer></v-spacer>
            <v-btn icon dark @click="hiddeAttachDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-alert outlined dense type="info" class="mt-2">
              <small>Tamaño máximo por archivo
                <strong>{{ max_size_file }}MB</strong></small>
            </v-alert>
            <p>
              <v-row class="mt-2">
                <div v-for="(file, index) in messageForm.files" :key="index" style="text-align: center">
                  <v-chip class="ma-4" close color="#f2f2f2" close-icon="mdi-delete" text-color="primary"
                    @click:close="deleteFileChatThumnail(index)">
                    <v-sheet color="white" elevation="1" height="100" width="100" class="m-10 p-5 preview">
                      <div style="text-align: center">
                        <img :src="file.url" v-if="file.type.match('image.*')" />
                        <v-icon class="mt-5" size="50" color="red"
                          v-if="file.type.match('pdf.*')">mdi-file-pdf-box</v-icon>
                        <v-icon class="mt-5" size="50" color="green"
                          v-if="file.type.match('excel.*')">mdi-file-excel</v-icon>
                        <v-icon class="mt-5" size="50" color="primary"
                          v-if="file.type.match('word.*')">mdi-file-word</v-icon>
                        <v-icon class="mt-5" size="50" color="orange"
                          v-if="file.type.match('presentation.*')">mdi-file-powerpoint</v-icon>
                        <v-icon class="mt-5" size="50" color="purple"
                          v-if="file.type.match('video.*')">mdi-file-video</v-icon>
                      </div>
                    </v-sheet>
                  </v-chip>
                  <p>
                    <small :title="file.name">{{
                      file.name.length > 30
                        ? file.name.substr(0, 20) + "..."
                        : file.name
                    }}
                    </small>
                  </p>
                </div>
              </v-row>
              <v-text-field v-model.trim="messageForm.content" label="Escribe un mensaje" type="text" no-details densed
                append-outer-icon="mdi-send" @keyup.enter="sendMessage()" @click:append-outer="sendMessage()"
                hide-details />
            </p>

            <div class="box-container justify-center">
              <span class="box color1-logo"></span>
              <span class="box color2-logo"></span>
              <span class="box color3-logo"></span>
              <span class="box color4-logo"></span>
              <span class="box color5-logo"></span>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="justify-space-around">
            <v-btn color="primary" text @click="hiddeAttachDialog()" small>
              Cancelar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <input id="file-upload" type="file" v-on:change="addImageGroup()" ref="fileInputGroup"
        style="visibility: hidden" />
      <input id="file-upload" type="file" v-on:change="onFilesChange" ref="filesChat" style="visibility: hidden"
        multiple="" />
    </template>
  </div>
</template>

<script>

import moment from "moment";
import { VEmojiPicker } from "v-emoji-picker";
import store from "../store/index";
moment.locale("es");


import SocketConnection from "itoeste-socket";
import { DEBUG, API_SOCKET } from "../../env";

export default {
  props: ['autoMessage'],
  components: {
    VEmojiPicker
  },
  data: () => ({
    messages: [],
    messageForm: {
      content: "",
      files: [],
    },
    isOnState: false,
    isModalVisible: false,
    isLoading: false,
    isInitialLoad: true,
    showSystemMessages: false,
    showEmojis: false,
    operadorNombre: '',
    rating: 0,
    opinion: '',
    modalStyle: {
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      background: 'white',
      padding: '20px',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
      zIndex: 1000,
    },
    modalContentStyle: {
      textAlign: 'center',
    },
    buttonStyle: {
      marginTop: '20px',
      padding: '10px 20px',
      backgroundColor: '#007bff',
      color: 'white',
      border: 'none',
      cursor: 'pointer',
    },
    limit: 10,
    showAlert: false,
    userMessageInput: '',
    scrollBehavior: 'auto',
    currentPage: null,    // Página actual (a actualizar después de cargar)
    lastPage: null,
    showQuestion: false,
    isSending: false,
    showOperadorButton: false,
    solicitaOperador: false,
    isWithOperador: false,
    ws: null,
    max_size_file: 30,
    today: moment().format("YYYY-MM-DD"),
    timeOut: undefined,
    showImageAttach: false,
  }),
  async mounted() {
    this.$nextTick(() => {
      this.$refs.chatgptMessages.scrollTop = this.$refs.chatgptMessages.scrollHeight;
      this.isInitialLoad = false;
    });

    this.ws = SocketConnection(
      {
        debug: DEBUG,
        token: API_SOCKET,
        user: this.$store.getters.user.IDStB,
      },
      () => { }
    );
    this.ws.subscribeChannel('operator-interception-' + this.$store.getters.user.IDStB, (e) => {
      console.log('Y eso que es ', this.$store.getters.user.IDStB)
      switch (e.action) {
        case "change-chats":
          if (e.isOn !== undefined) {
            this.isOnState = e.isOn; // Guardar el valor de isOn en la variable solo si no es undefined
          }
          break;
      }
    });
    this.ws.subscribeChannel("operator-change", async (result) => {
      let url;
      switch (result.action) {
        case "reasignar-operador":
          url = "chatgpt/monitorear-operador";
          await this.$API.get({ url: url }, false).then((res) => {
            console.log('ESTA ES LA RESPUESTA----->', res);
            if (res.assignmentOperator === true && res.operatorResponse == 0) {
              this.solicitaOperador = true;

              const timer = parseInt(res.tiempo) * 60000;

              this.timeOut = setTimeout(() => {
                this.notiOperatorChangeChat();
                setTimeout(() => {
                  this.eliminarOperador();
                }, timer * 0.25);
              }, timer * 0.75);
            }
          });
          break;
        // Otros casos de acción si los hay
      }
    });

    this.ws.subscribeChannel("chat-operador-" + this.$store.getters.user.IDStB, (result) => {

      switch (result.action) {
        case "message-new":
          // Acaba de recibir un nuevo mensaje
          this.onReceiveMessage(JSON.parse(result.message));
          break;
        case "first-operator-message":
          clearTimeout(this.timeOut);

          break
        case "message-delete":
          // Se elimino un mensaje
          this.onDeleteMessage(result);
          break;
        case "close-mode-operator":
          // Operador acaba de abandonar el chat
          this.isWithOperador = false;
          store.dispatch("snackbar", {
            view: true,
            text: 'El operador ha abandonado el chat',
            config: { color: "success" }
          });
          this.onReceiveMessage();
          this.openModal();
          break;
        case "close-mode-operator-r":
          // Operador acaba de abandonar el chat
          this.isWithOperador = false;
          store.dispatch("snackbar", {
            view: true,
            text: 'El operador ha abandonado el chat',
            config: { color: "success" }
          });
          this.onReceiveMessage();
          break;
      }
    });
    this.getLastPage()
    this.$refs.chatgptMessages.addEventListener('scroll', this.handleScroll);
    await this.loadChatgpt();
    this.scrollChatgpt();
  },
  beforeDestroy() {
    this.$refs.chatgptMessages.removeEventListener('scroll', this.handleScroll);
  },
  beforeMount() {
    this.getLastPage();
  },

  methods: {
    async getLastPage() {
      console.log('Llamando a getLastPage()'); // Log para verificar que se llama el método

      try {
        const res = await this.$API.get({ url: 'chatgpt/index' }, false);
        if (res && res.response) {
          this.lastPage = res.response.lastPage;
          this.currentPage = this.lastPage;
          console.log('Última página obtenida:', this.lastPage); // Log para verificar la última página
          this.loadChatgpt(); // Llama a loadChatgpt con la última página
        } else {
          console.error('Estructura inesperada de la respuesta para obtener la última página');
        }
      } catch (error) {
        console.error('Error al obtener la última página:', error);
      }
    },

    selectEmoji(emoji) {
      this.messageForm.content += emoji.data;
    },
    async submitRating() {
      console.log('Rating enviado:', this.rating);
      console.log('Opinión enviada:', this.opinion);

      // Crear el objeto de datos
      const data = {
        rating: this.rating,
        opinion: this.opinion,
        nombre_operador: this.operadorNombre,
        id_alumno: this.$store.getters.user.IDStB,
      };

      let url = 'operadores/encuestas';

      try {
        let response = await this.$API.post({
          url: url,
          data: data
        }, false);

        console.log('Respuesta del servidor:', response.data);

        // Cerrar el modal solo si la solicitud fue exitosa
        this.rating = 0;
        this.opinion = '';
        this.operadorNombre = null;
        this.closeModal();

      } catch (error) {
        console.error('Error:', error);
        // Aquí puedes manejar el error, mostrar un mensaje al usuario, etc.
      }
    },
    openModal() {
      // Lógica para abrir el modal
      this.isModalVisible = true;
    },
    closeModal() {
      // Lógica para cerrar el modal
      this.isModalVisible = false;
    },
    playSound() {
      const sound = require("@/assets/notification.mp3");
      var audio = new Audio(sound);
      audio.play();
    },

    async attachFile() {
      this.$refs.filesChat.click();

    },

    getType_(file) {
      let alloweds = [
        { t: "pdf", c: "red" },
        { t: "word", c: "blue" },
        { t: "image", c: null },
        { t: "video", c: "purple" },
        { t: "excel", c: "green" },
        { t: "presentation", c: "orange" },
      ];
      let type = null;
      alloweds.forEach((allowed) => {
        if (file.type.match(allowed.t + ".*")) {
          type = allowed;
        }
      });
      return type;
    },

    isAllowed(file) {
      let alloweds = ["pdf", "word", "image", "video", "excel", "presentation"];
      let allowed = false;
      alloweds.forEach((mime) => {
        if (file.type.match(mime + ".*")) {
          allowed = true;
        }
      });
      return allowed;
    },

    hasAllowedSize(file) {
      let allowed = false;
      let limit = this.max_size_file * 1024 * 1024;
      if (file.size <= limit) {
        allowed = true;
      }
      return allowed;
    },

    getType(file) {
      let alloweds = ["pdf", "word", "image", "video", "excel", "presentation"];
      let type = "";
      alloweds.forEach((mime) => {
        if (file.type.match(mime + ".*")) {
          type = mime;
        }
      });
      return type;
    },

    onFilesChange(e) {

      let all = [...e.target.files];

      if (all.length > 0) {
        all.forEach((val) => {
          if (this.messageForm.files.length < this.limit) {
            if (val.type.match('image.*') || val.type.match('pdf.*') || val.type.match('word.*') || val.type.match('video.*') || val.type.match('excel.*') || val.type.match('presentation.*')) {
              val.url = URL.createObjectURL(val);
              if (this.isAllowed(val) && this.hasAllowedSize(val)) {
                this.messageForm.files.push(val);
              }
            }
          }
        });
        if (this.messageForm.files.length > 0) {
          this.showImageAttach = true;
        } else {
          this.showAlert = true;
          this.contentAlert = "Imposible enviar esos archivos";
          this.typeAlert = "modal-danger";
        }
      }
    },

    addImageGroup() {
      let val = this.$refs.fileInputGroup.files[0];
      if (val.type.match("image.*")) {
        val.url = URL.createObjectURL(val);
        this.chatActive.image = val.url;
      }
    },

    deleteFileChatThumnail(index) {
      this.messageForm.files.splice(index, 1);
    },

    hiddeAttachDialog() {
      this.showImageAttach = false;
      this.messageForm.files = [];
    },

    //Atrapa el evento cuando se agrega un mensaje
    onReceiveMessage(data) {
      // if ( this.$store.getters.user.IDStB != data.user_id) {
      //   this.playSound();
      // }
      console.log(data)
      this.solicitaOperador = false;
      this.showOperadorButton = false;
      this.isWithOperador = true;
      this.loadChatgpt();
    },
    onDeleteMessage(data) {
      console.log(data)
    },

    async sendMessage(files) {
      files = this.messageForm.files;


      this.isSending = true;

      // Asignar un valor predeterminado si no hay mensaje
      let messageContent = this.messageForm.content.trim() || "";

      // Solo añadir el mensaje al array de mensajes si hay contenido
      if (messageContent) {
        this.messages.push({
          user: true,
          text: messageContent
        });
      }

      this.userMessageInput = messageContent;
      this.messageForm.content = "";
      this.showQuestion = true;
      this.scrollChatgpt();

      let formData = new FormData();
      formData.append("userMessage", this.userMessageInput);

      if (files && files.length > 0) {
        files.forEach(file => {
          formData.append("file", file);
          formData.append("type", this.getType(file));
        });
      }

      // Si isWithOperador cambia a false, forzamos isOnState también a false
      if (!this.isWithOperador) {
        this.isOnState = false;
      }

      // Definir la URL según el valor de isWithOperador
      let url = this.isWithOperador ? "operadores/messages" : "chatgpt/store";

      try {
        const res = await this.$API.post({
          url: url,
          data: formData
        }, false);

        if (this.autoMessage && !this.isWithOperador) {
          await this.loadChatgpt(null, null, files);
          this.isSending = false;
          this.solicitaOperador = true;
        }

        await this.loadChatgpt(null, null, files);
        this.isSending = false;

        if (res.habilitarBtnOperador == 1) {
          this.showOperadorButton = true;
        }

        this.messageForm.files = [];
        this.messageForm.content = "";

      } catch (error) {
        console.log('Error:', error);
        this.isSending = false;
      } finally {
        this.showImageAttach = false;
      }
    },

    handleScroll() {
      if (this.isInitialLoad) return; // Skip handling during initial load

      const scrollTop = this.$refs.chatgptMessages.scrollTop;
      const threshold = 50; // Increased threshold value

      // Check if the user is within the threshold from the top
      if (scrollTop <= threshold && !this.isLoading) {
        // Load previous page if not on the first page
        if (this.currentPage > 1) {
          this.loadChatgpt(this.currentPage - 1);
        }
      }
    },
    async loadChatgpt(page = null) {
      if (this.isLoading) return;
      this.isLoading = true;

      // Si no se proporciona una página, usamos la última página conocida
      if (page === null) {
        page = this.lastPage;
      }

      let url = `chatgpt/index?page=${page}`;
      await this.$API.get({ url: url }, false)
        .then((res) => {
          if (page === this.lastPage) {
            // Al cargar la última página, reemplazamos los mensajes actuales
            this.messages = res.response.data;
          } else {
            // Al cargar páginas anteriores, añadimos los mensajes al principio
            this.messages = [...res.response.data, ...this.messages];
          }

          this.showQuestion = false;

          if (res && res.response && Array.isArray(res.response.data)) {
            const dataLength = res.response.data.length;
            if (dataLength > 0) {
              const ultimoObjeto = res.response.data[dataLength - 1];
              if (ultimoObjeto.operator_name != null) {
                console.log('Nombre del operador:', ultimoObjeto.operator_name);
                this.operadorNombre = ultimoObjeto.operator_name;
              } else {
                console.log('El último objeto no tiene un operator_name válido.');
              }
            } else {
              console.log('El array está vacío');
            }
          } else {
            console.error('Estructura inesperada de res o res.response.data no es un array');
          }

          this.isWithOperador = res.response.chatgptData.mode_operator == 1 ? true : false;
          this.currentPage = res.response.currentPage;
          this.lastPage = res.response.lastPage;

          if (page === this.lastPage) {
            this.scrollChatgpt(); // Llamada para ajustar el scroll si es necesario
          }

          this.isLoading = false;
        })
        .catch((error) => {
          console.error('Error al cargar los mensajes:', error);
          this.isLoading = false;
        });
    },

    async notiOperatorChangeChat() {
      await this.$API.post({ url: "chatgpt/poco-tiempo-operador" }, false)
    },

    async eliminarOperador() {
      console.log('eliminando operador')
      this.showOperadorButton = false;

      let url = "chatgpt/limpiar-operador";
      await this.$API
        .post({
          url: url,
        },
        ).then(() => {
          this.solicitarOperador()
        });
    },

    async solicitarOperador() {
      console.log('solicitando operador')
      this.showOperadorButton = false;

      let url = "chatgpt/asignar-operador";
      await this.$API
        .post({
          url: url,
        },
        ).then((res) => {
          this.solicitaOperador = true;
          const timer = (parseInt(res.tiempo)) * 60000;
          this.timeOut = setTimeout(() => {
            this.notiOperatorChangeChat();
            setTimeout(() => {
              this.eliminarOperador();
            }, timer * 0.25);
          }, timer * 0.75);

        });
    },

    scrollChatgpt() {
      this.$nextTick(() => {
        const chatgptMessages = this.$refs.chatgptMessages;
        // chatgptMessages.scrollTop = chatgptMessages.scrollHeight;
        chatgptMessages.scrollTo({
          top: chatgptMessages.scrollHeight,
          behavior: 'auto'
        });
      });
    },
  },
  computed: {
    groupedMessages() {
      const grouped = {};
      this.messages.forEach(msg => {
        const fecha = msg.fecha;
        if (!grouped[fecha]) {
          grouped[fecha] = [];
        }
        grouped[fecha].push(msg);
      });
      return grouped;
    }
  },
}
</script>

<style scoped>
.chat-container {
  height: 500px;
  /* Ajusta según sea necesario */
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  /* Muestra los mensajes más recientes en la parte inferior */
}

.floating-button-container {
  position: absolute;
  bottom: 90px;
  right: 50px;
}

.floating-button-solicitud {
  padding: 10px 15px;
  background-color: #64B5F6;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  text-transform: lowercase;
}

/* #4CAF50 A7BA38*/
.floating-button-success {
  padding: 10px 15px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  text-transform: lowercase;
}

.floating-button-waiting {
  padding: 10px 15px;
  background-color: gray;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  text-transform: lowercase;
}
</style>